import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Error404 from './pages/error404';
import Book from './pages/book';
import Explore from './pages/explore';
import Login from './pages/login';
import Onboarding from './pages/onboarding';
import Signup from './pages/signup';
import Map from './pages/map';
import Events from './pages/events';
import ComingSoon from './pages/comingSoon';
import Notifications from './pages/notifications';

const Path = () => {
    return ( <>
    <BrowserRouter>
        <Routes>
            <Route path='/' element={<Onboarding />} />
            <Route path='/Login' element={<Login />} />
            <Route path='/Signup' element={<Signup />} />
            <Route path='/Home' element={<Home />} />
            <Route path='/Book' element={<Book />} />
            <Route path='/Explore' element={<Explore />} />
            <Route path='/Map' element={<Map />} />
            <Route path='/Events' element={<Events />} />
            <Route path='/ComingSoon' element={<ComingSoon />} />
            <Route path='/Notifications' element={<Notifications />} />
            <Route path='*' element={<Error404 />} />
        </Routes>
    </BrowserRouter>
    </> );
}
 
export default Path;